import { render, staticRenderFns } from "./Drawings.vue?vue&type=template&id=5352b4dc&"
import script from "./Drawings.vue?vue&type=script&lang=js&"
export * from "./Drawings.vue?vue&type=script&lang=js&"
import style0 from "./Drawings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports